import { useMemo } from 'react';
import * as RouterDom from 'react-router-dom';

function useQuery() {
  const defaultRouter =
    typeof RouterDom === undefined
      ? RouterDom?.useLocation().search
      : window.location.search;

  return useMemo(() => new URLSearchParams(defaultRouter), [defaultRouter]);
}

export default useQuery;
